import localStorageKeys from "@constants/localStorageKeys";

export const hasClickedOnToggleButton = (): boolean => {
  return localStorage.getItem(localStorageKeys.PRODUCT_FRUITS_HAS_CLICKED_TOGGLE_BUTTON) === "true";
};

export const setToggleButtonPressed = (isPressed: boolean): void => {
  localStorage.setItem(
    localStorageKeys.PRODUCT_FRUITS_HAS_CLICKED_TOGGLE_BUTTON,
    isPressed.toString(),
  );
};
